import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from 'emotion-theming';
import {
  Minus,
  NumberCircleOne,
  NumberCircleThree,
  NumberCircleTwo,
} from 'phosphor-react';
import { ThemeProps } from '../../../types';

export interface BreadcrumbProps {
  /**
   * The css class for the input. Handled internally by emotion
   */
  className?: string;
  /**
   * The current pageNumber the user is on
   */
  pageNumber: number;
}

const Breadcrumb = ({ className, pageNumber }: BreadcrumbProps) => {
  const theme: ThemeProps = useTheme();

  return (
    <div className={className}>
      <NumberCircleOne
        className='step'
        color={theme.colors.accent}
        size={24}
        weight='fill'
      />
      <Minus
        color={
          pageNumber === 2 || pageNumber === 3
            ? theme.colors.accent
            : theme.colors.common.grey
        }
        size={24}
        style={{ marginLeft: -6, marginRight: -6 }}
        weight='bold'
      />
      <NumberCircleTwo
        className='step'
        color={
          pageNumber === 2 || pageNumber === 3
            ? theme.colors.accent
            : theme.colors.common.grey
        }
        size={24}
        weight='fill'
      />
      <Minus
        color={
          pageNumber === 3 ? theme.colors.accent : theme.colors.common.grey
        }
        size={24}
        style={{ marginLeft: -6, marginRight: -6 }}
        weight='bold'
      />
      <NumberCircleThree
        className='step'
        color={
          pageNumber === 3 ? theme.colors.accent : theme.colors.common.grey
        }
        size={24}
        weight='fill'
      />
    </div>
  );
};

const StyledBreadcrumb = styled((props: any) => <Breadcrumb {...props} />)`
  ${() => ({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    '.step': {
      zIndex: 1,
    },
  })}
`;

export default StyledBreadcrumb;
